module.exports = __webpack_public_path__ + "img/no-roles.77740eac.svg";